module.exports = "/images/marking-icon-note_new.svg?0ebd0329c2ac26205db7fea3918ccb1c";